//-------------------------------------------------------------------------------------------------- Imports
import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

//-------------------------------------------------------------------------------------------------- Types
type NavigationGuard = (proceed: () => void) => void;

//-------------------------------------------------------------------------------------------------- Hook
// Intercepta las navegaciones internas (menú, notificaciones, botón regresar) mientras `when` sea
// true. Se envuelve el navigator del router porque `useBlocker` requiere un data router y la app usa
// BrowserRouter. Recargar o cerrar la pestaña muestra el aviso nativo del navegador.
const useNavigationGuard = (when: boolean, guard: NavigationGuard) => {
    const { navigator } = useContext(UNSAFE_NavigationContext);

    useEffect(() => {
        if (!when) return;

        const { push, replace } = navigator;
        navigator.push = (...args: Parameters<typeof push>) => guard(() => push(...args));
        navigator.replace = (...args: Parameters<typeof replace>) => guard(() => replace(...args));

        const onBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = "";
        };
        window.addEventListener("beforeunload", onBeforeUnload);

        return () => {
            navigator.push = push;
            navigator.replace = replace;
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, [navigator, when, guard]);
};

//-------------------------------------------------------------------------------------------------- Exports
export default useNavigationGuard;
